export class ManufacturerCode {
  [key: string]: any;
  _id?: string;
  _rev?: string;
  type?: string = "manufacturerCode";
  cageCode: string[] = [];
  manufacturerName: string = "";
}
